import { render, staticRenderFns } from "./courseBalanceCosts.vue?vue&type=template&id=6ca66c22&"
import script from "./courseBalanceCosts.vue?vue&type=script&lang=js&"
export * from "./courseBalanceCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports